import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import { Card, ListItemIcon, ListItemText, MenuItem, Stack, Typography } from "@mui/material";
import { useContext, useRef } from "react";
import { GroupPlanningUserGroupInfos } from "../../../Core/Api/Types/group-planning-user-group-infos";
import MoreMenu, { MoreMenuHandle } from "../../Misc/MoreMenu";
import { ModalContext } from "../../Modals";
import ModalConfirmAction, {
  ModalConfirmActionElementProps,
} from "../../Modals/ModalConfirmAction/modal-confirm-action";
import ModalCreateOrUpdatePlanningUserGroup, {
  ModalCreateOrUpdatePlanningUserGroupElementProps,
} from "../../Modals/ModalCreateOrUpdatePlanningUserGroup/modal-create-or-update-planning-user-group";
import { useTranslation } from "react-i18next";

export interface PlanningUserGroupCardProps {
  userGroup: GroupPlanningUserGroupInfos;
  editUserGroupInGroup: (userGroup: GroupPlanningUserGroupInfos) => void;
  deleteUserGroupOfGroup: (userGroup: GroupPlanningUserGroupInfos) => void;
}

const PlanningUserGroupCard = (props: PlanningUserGroupCardProps) => {
  const { t } = useTranslation();
  const { userGroup, editUserGroupInGroup, deleteUserGroupOfGroup } = props;

  const modalContext = useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const moreMenuRef = useRef<MoreMenuHandle>(null);

  const handleEditUserGroup = () => {
    if (!openModal) return;
    openModal<ModalCreateOrUpdatePlanningUserGroupElementProps>(ModalCreateOrUpdatePlanningUserGroup, {
      mode: "update",
      existingGroup: userGroup,
      addUserGroupToGroup: (_) => false,
      editUserGroupInGroup: editUserGroupInGroup,
    });
    moreMenuRef.current?.closeMenu();
  };

  const handleDeleteUserGroup = () => {
    if (!openModal) return;
    openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
      onConfirm: (_) => deleteUserGroupOfGroup(userGroup),
      title: t("modal:title.confirmUserGroupDeletion"),
    });
  };

  return (
    <Card variant="outlined" sx={{ p: 1, m: 1 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
        <Typography variant="h5">{userGroup.name}</Typography>
        <MoreMenu ref={moreMenuRef} direction="vertical" size="small" sx={{ color: "text.secondary" }}>
          <MenuItem onClick={handleEditUserGroup}>
            <ListItemIcon>
              <ModeEditOutlinedIcon />
            </ListItemIcon>
            <ListItemText>{t("common:editUpperCase")}</ListItemText>
          </MenuItem>
          <MenuItem onClick={handleDeleteUserGroup}>
            <ListItemIcon>
              {" "}
              <DeleteOutlinedIcon color="error" />
            </ListItemIcon>
            <ListItemText>{t("common:delete")}</ListItemText>
          </MenuItem>
        </MoreMenu>
      </Stack>
    </Card>
  );
};

export default PlanningUserGroupCard;
